import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Banner from 'components/Banner';
import DistributionContacts from 'components/DistributionContacts';
import ContactsCards from './ContactsCards';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import { useDispatch, useSelector } from 'react-redux';
import React, { useRef } from 'react';
import { selectContactsPage, selectContactsPageIsLoading } from 'store/slices/ContactsSlice';
import { fetchContacts } from 'store/slices/ContactsSlice';
import { scrollToSection } from 'helpers';
import { useLocation } from 'react-router-dom';
import { useAnimation, useAnimationWithStagger } from 'hooks/useAnimation';
import Preloader from 'Layout/Preloader';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Contacts = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const {
        fs_title,
        fs_background,
        fs_button,
        international_tag,
        international_title,
        international_text,
        contacts,
        contact_tag,
        contact_title,
    } = useSelector(selectContactsPage);
    const loading = useSelector(selectContactsPageIsLoading);

    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchContacts());
    }, [dispatch]);

    console.log(loading);

    React.useEffect(() => {
        if (location.hash === '#find') {
            scrollToSection('distribution-contacts', 100);
        }
    }, [location.hash]);

    const handleClick = () => scrollToSection('form-section');

    const container = useRef();
    // useGSAP(
    //     () => {
    //         let targets = gsap.utils.toArray([
    //             '.banner-title',
    //             '.has-animation',
    //             '.distribution-contacts',
    //             '.form-section',
    //         ]);
    //         targets.forEach(item =>
    //             gsap.from(item, {
    //                 y: 10,
    //                 opacity: 0,
    //                 ease: 'power1.in',
    //                 duration: 0.4,
    //                 scrollTrigger: {
    //                     trigger: item,
    //                     start: 'top 75%',
    //                     markers: true,
    //                 },
    //                 onStart: () => {
    //                     console.log('onStart', { item });
    //                 },
    //                 onComplete: () => {
    //                     console.log('onComplete', { item });
    //                 },
    //             }),
    //         );
    //     },
    //     { dependencies: [loading, location], scope: container, revertOnUpdate: true },
    // );
    // useAnimation({
    //     items: ['.banner-title', '.has-animation', '.distribution-contacts', '.form-section'],
    //     container,
    //     dependencies: [loading],
    // });

    // useAnimationWithStagger({
    //     item: '.contact-card',
    //     trigger: '.contacts-cards',
    //     container,
    //     dependencies: [loading, location],
    // });

    return (
        <div ref={container}>
            <Banner title={fs_title} image={fs_background} buttonText={fs_button} onClickButton={handleClick} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{international_tag}</LabelButton>
                        <GradientText className="has-animation">
                            <span dangerouslySetInnerHTML={{ __html: international_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small" className="has-animation">
                                {international_text}
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <DistributionContacts />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{contact_tag}</LabelButton>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="middle" className="has-animation">
                                <span dangerouslySetInnerHTML={{ __html: contact_title }} />
                            </GradientText>
                        </div>
                    </div>

                    <ContactsCards data={contacts} />
                </div>
            </section>

            <DefaultForm />
        </div>
    );
};

export default Contacts;
